import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { bufferCount } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TimerService {
  private _second$: Observable<number>;

  public get second$(): Observable<number> {
    const result = this._second$ || (this._second$ = timer(0, 1000));

    return result;
  }

  public get minute$(): Observable<number[]> {
    return this.second$.pipe(bufferCount(60));
  }
}
